<template>
  <div class="footer">
    <div class="logo">XLAG.cn</div>
    <div class="center">
      互联网ICP备案：
      <a class="link-txt" href="https://beian.miit.gov.cn">豫ICP备2025138733号-4</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="less">
.footer {
  width: 100vw;
  height: 80px;
  line-height: 80px;
  background-color: #252525;
  text-align: center;
  min-width: 996px;
  max-width: 100vw;
  position: relative;

  .logo {
    font-family: "logo";
    font-size: 32px;
    padding: 0 4px;
    border-radius: 5px;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 40px;
    transform: translateY(-50%);
  }

  .center {
    color: #fff;
    font-size: 14px;

    .link-txt {
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      text-decoration: none;
      outline: none;
      padding: 0;
      transition: all .2s linear;
    }
  }
}
</style>